import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";

const PageContainer = styled.div`
  padding-top: 80px;
  min-height: 100vh;
  background: linear-gradient(135deg, #faf5ff 0%, #ede9fe 100%);
`;

const ContentWrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
`;

const Breadcrumbs = styled.nav`
  margin-bottom: 30px;
  font-size: 14px;
  color: #666;

  a {
    color: #7c3aed;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  span {
    margin: 0 8px;
    color: #999;
  }
`;

const Header = styled.header`
  text-align: center;
  margin-bottom: 40px;
`;

const AppBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #7c3aed;
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 20px;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: #1a1a1a;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const LastUpdated = styled.p`
  color: #666;
  font-size: 14px;
`;

const Card = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 40px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    padding: 25px;
  }
`;

const TableOfContents = styled.div`
  background: #faf5ff;
  border-left: 4px solid #7c3aed;
  padding: 20px 25px;
  border-radius: 0 8px 8px 0;
  margin-bottom: 30px;

  h3 {
    color: #1a1a1a;
    margin-bottom: 15px;
    font-size: 1.1rem;
  }

  ol {
    margin: 0;
    padding-left: 20px;
  }

  li {
    margin-bottom: 8px;
  }

  a {
    color: #7c3aed;
    text-decoration: none;
    font-size: 15px;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const Section = styled.section`
  margin-bottom: 35px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const SectionTitle = styled.h2`
  color: #1a1a1a;
  font-size: 1.4rem;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e9d5ff;
  display: flex;
  align-items: center;
  gap: 10px;

  .icon {
    color: #7c3aed;
  }
`;

const Paragraph = styled.p`
  color: #444;
  line-height: 1.8;
  margin-bottom: 15px;
  font-size: 15px;
`;

const ContactCard = styled.div`
  background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
  color: white;
  padding: 25px;
  border-radius: 12px;
  text-align: center;

  h3 {
    margin-bottom: 15px;
    font-size: 1.2rem;
  }

  p {
    margin-bottom: 10px;
    font-size: 15px;
  }

  a {
    color: white;
    font-weight: 600;
  }
`;

const RelatedLinks = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 30px;
  flex-wrap: wrap;

  a {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #f5f3ff;
    color: #7c3aed;
    padding: 12px 20px;
    border-radius: 8px;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.2s;

    &:hover {
      background: #7c3aed;
      color: white;
    }
  }
`;

export const InstrumentSnapTermsPage = () => {
  return (
    <>
      <Navbar />
      <PageContainer>
        <ContentWrapper>
          <Breadcrumbs>
            <Link to="/">Inicio</Link>
            <span>›</span>
            <span>Terminos de Servicio - InstrumentSnap</span>
          </Breadcrumbs>

          <Header>
            <AppBadge>
              InstrumentSnap
            </AppBadge>
            <Title>Terminos de Servicio</Title>
            <LastUpdated>Ultima actualizacion: 22 de febrero de 2026</LastUpdated>
          </Header>

          <Card>
            <TableOfContents>
              <h3>Tabla de Contenidos</h3>
              <ol>
                <li><a href="#aceptacion">Aceptacion de los Terminos</a></li>
                <li><a href="#descripcion">Descripcion del Servicio</a></li>
                <li><a href="#cuentas">Cuentas de Usuario</a></li>
                <li><a href="#suscripciones">Suscripciones y Pagos</a></li>
                <li><a href="#uso-aceptable">Uso Aceptable</a></li>
                <li><a href="#contenido-usuario">Contenido del Usuario</a></li>
                <li><a href="#propiedad-intelectual">Propiedad Intelectual</a></li>
                <li><a href="#limitacion">Limitacion de Responsabilidad</a></li>
                <li><a href="#garantias">Exclusion de Garantias</a></li>
                <li><a href="#indemnizacion">Indemnizacion</a></li>
                <li><a href="#terminacion">Terminacion</a></li>
                <li><a href="#modificaciones">Modificaciones</a></li>
                <li><a href="#ley-aplicable">Ley Aplicable</a></li>
                <li><a href="#contacto">Contacto</a></li>
              </ol>
            </TableOfContents>

            <Section id="aceptacion">
              <SectionTitle>
                <span className="icon">1.</span> Aceptacion de los Terminos
              </SectionTitle>
              <Paragraph>
                Contenido pendiente. Esta seccion describira las condiciones de aceptacion de los
                terminos de servicio de InstrumentSnap por parte del usuario.
              </Paragraph>
            </Section>

            <Section id="descripcion">
              <SectionTitle>
                <span className="icon">2.</span> Descripcion del Servicio
              </SectionTitle>
              <Paragraph>
                Contenido pendiente. Esta seccion detallara las funcionalidades y caracteristicas
                del servicio InstrumentSnap.
              </Paragraph>
            </Section>

            <Section id="cuentas">
              <SectionTitle>
                <span className="icon">3.</span> Cuentas de Usuario
              </SectionTitle>
              <Paragraph>
                Contenido pendiente. Esta seccion explicara las responsabilidades del usuario respecto
                a su cuenta.
              </Paragraph>
            </Section>

            <Section id="suscripciones">
              <SectionTitle>
                <span className="icon">4.</span> Suscripciones y Pagos
              </SectionTitle>
              <Paragraph>
                Contenido pendiente. Esta seccion describira los planes de suscripcion, precios
                y condiciones de pago.
              </Paragraph>
            </Section>

            <Section id="uso-aceptable">
              <SectionTitle>
                <span className="icon">5.</span> Uso Aceptable
              </SectionTitle>
              <Paragraph>
                Contenido pendiente. Esta seccion indicara las normas de uso aceptable de la
                aplicacion InstrumentSnap.
              </Paragraph>
            </Section>

            <Section id="contenido-usuario">
              <SectionTitle>
                <span className="icon">6.</span> Contenido del Usuario
              </SectionTitle>
              <Paragraph>
                Contenido pendiente. Esta seccion explicara los derechos y responsabilidades sobre
                el contenido generado por los usuarios.
              </Paragraph>
            </Section>

            <Section id="propiedad-intelectual">
              <SectionTitle>
                <span className="icon">7.</span> Propiedad Intelectual
              </SectionTitle>
              <Paragraph>
                Contenido pendiente. Esta seccion detallara los derechos de propiedad intelectual
                de InstrumentSnap y Monaco IT Services.
              </Paragraph>
            </Section>

            <Section id="limitacion">
              <SectionTitle>
                <span className="icon">8.</span> Limitacion de Responsabilidad
              </SectionTitle>
              <Paragraph>
                Contenido pendiente. Esta seccion describira las limitaciones de responsabilidad
                del servicio.
              </Paragraph>
            </Section>

            <Section id="garantias">
              <SectionTitle>
                <span className="icon">9.</span> Exclusion de Garantias
              </SectionTitle>
              <Paragraph>
                Contenido pendiente. Esta seccion explicara las exclusiones de garantias aplicables
                al servicio.
              </Paragraph>
            </Section>

            <Section id="indemnizacion">
              <SectionTitle>
                <span className="icon">10.</span> Indemnizacion
              </SectionTitle>
              <Paragraph>
                Contenido pendiente. Esta seccion detallara las obligaciones de indemnizacion
                del usuario.
              </Paragraph>
            </Section>

            <Section id="terminacion">
              <SectionTitle>
                <span className="icon">11.</span> Terminacion
              </SectionTitle>
              <Paragraph>
                Contenido pendiente. Esta seccion describira las condiciones bajo las cuales se puede
                terminar el servicio o la cuenta.
              </Paragraph>
            </Section>

            <Section id="modificaciones">
              <SectionTitle>
                <span className="icon">12.</span> Modificaciones
              </SectionTitle>
              <Paragraph>
                Contenido pendiente. Esta seccion indicara como se notificaran los cambios a estos
                terminos de servicio.
              </Paragraph>
            </Section>

            <Section id="ley-aplicable">
              <SectionTitle>
                <span className="icon">13.</span> Ley Aplicable
              </SectionTitle>
              <Paragraph>
                Contenido pendiente. Esta seccion especificara la jurisdiccion y ley aplicable
                a estos terminos.
              </Paragraph>
            </Section>

            <Section id="contacto">
              <SectionTitle>
                <span className="icon">14.</span> Contacto
              </SectionTitle>
              <Paragraph>
                Si tiene preguntas sobre estos Terminos de Servicio, puede contactarnos:
              </Paragraph>
              <ContactCard>
                <h3>Monaco IT Services</h3>
                <p>Email: <a href="mailto:support@monaco-it-services.cl">support@monaco-it-services.cl</a></p>
                <p>Sitio web: <a href="https://monaco-it-services.cl" target="_blank" rel="noopener noreferrer">monaco-it-services.cl</a></p>
                <p>Pais: Chile</p>
              </ContactCard>
            </Section>

            <RelatedLinks>
              <Link to="/instrumentsnap/privacy">
                Politica de Privacidad
              </Link>
              <Link to="/">
                Volver al Inicio
              </Link>
            </RelatedLinks>
          </Card>
        </ContentWrapper>
      </PageContainer>
      <Footer />
    </>
  );
};
